import { AboutUs } from '../Components/AboutUs';
import { AminoAcids } from '../Components/AminoAcids';
import { HeroCarousel } from '../Components/HeroCarousel';
import { Products } from '../Components/Products';
import { QuotePeptide } from '../Components/QuotePeptide';
import { Speciality } from '../Components/Speciality';
import { Testimonials } from '../Components/Testimonials';
import { Blogs } from '../Components/Blogs';
import { Faq } from '../Components/Faq';
import { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';

interface HomeProps {
  // Define any props your component might need
  ref: any,
  productRef: any,
  scrollToProducts: () => void;
}


export const Home = forwardRef<HTMLDivElement, HomeProps>((props, ref) => {
  return (
    <>
    <Helmet>
      <title>Automated Peptide Synthesizers</title>
      <meta name='description' content='Peptide Machines offer patented, fully automated peptide synthesizer Instruments—designed for efficient, high-quality peptide synthesis using multi-reactor systems like Discovery-4 and Discovery-12.' />
    </Helmet>
    <div>
        <HeroCarousel scrollToProducts={props.scrollToProducts}/>
        <Products ref={props.productRef} />
        <AminoAcids />
        <QuotePeptide />
        <Speciality />
        <AboutUs />
        <Testimonials />
        <Blogs />
        <Faq  ref={ref}/>
    </div>
    </>
  )
})
